export default "__VITE_ASSET__0bdRlrAW__"